import { render, staticRenderFns } from "./ArticleDivider.vue?vue&type=template&id=63f0da33&"
import script from "./ArticleDivider.vue?vue&type=script&lang=js&"
export * from "./ArticleDivider.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDivider.vue?vue&type=style&index=0&id=63f0da33&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports